import React, { useState } from 'react';
import styles from '../TargetAudience.module.css';

import DebounceInput from '../../../../../campaigns/components/DebounceInput/DebounceInput';

import checkAgeGroupsSum from '../helpers/checkAgeGroupsSum/checkAgeGroupsSum';
import resetCrossedSample from '../helpers/resetCrossedSample/resetCrossedSample';

const TargetAudienceTab = props => {
  const {
    survey,
    onUpdateSurvey,
    userFilter,
    filterSettings,
    onUserFilterChange
  } = props;

  const [maxResponses, setMaxResponses] = useState(survey.maxResponses);

  return (
    <div className={styles.container}>
      <div className={styles.blockContainer}>
        <div className={styles.singleBlock}>
          <div className={`${styles.label} ${styles.descriptionCorrected}`}>
            Total sample size
          </div>
          <DebounceInput
            initialValue={maxResponses || ''}
            onChangeValue={value => {
              setMaxResponses(value);
              onUpdateSurvey({ maxResponses: value }, 0);
              if (
                userFilter &&
                filterSettings &&
                filterSettings.crossedSample &&
                checkAgeGroupsSum(userFilter, maxResponses) !== 100
              ) {
                const newUserFilter = { ...userFilter };
                resetCrossedSample(
                  newUserFilter,
                  filterSettings,
                  onUserFilterChange
                );
              }
            }}
            className={styles.description}
            placeholder="Enter value here.."
            type="number"
            onKeyDown={evt =>
              evt.key === 'ArrowDown' ||
              evt.key === 'ArrowUp' ||
              evt.key === 'e' ||
              evt.key === 'E' ||
              evt.key === '.' ||
              evt.key === '-'
                ? evt.preventDefault()
                : null
            }
            debounceTime={300}
          />
        </div>
      </div>
    </div>
  );
};

export default TargetAudienceTab;
